import { ApplicationType, CreditApplication } from '@trnsact/trnsact-shared-types';

class VendorOpportunityService {
  public getCustomerName(creditApplication?: CreditApplication & Record<string, any>) {
    if (!creditApplication) {
      return;
    }
    if (!creditApplication.applicationType) {
      console.error('Credit application type is undefined or null');

      return;
    }

    if (creditApplication.applicationType === ApplicationType.Commercial) {
      const businessCustomerName = creditApplication.businessName;

      if (!businessCustomerName) {
        console.error('Commercial customer name is undefined or null');

        return;
      }

      return businessCustomerName;
    }

    if (creditApplication.applicationType === ApplicationType.Individual) {
      const individualCustomerName = [creditApplication.firstName, creditApplication.lastName]
        .filter(Boolean)
        .join(' ');

      if (!individualCustomerName) {
        console.error('Individual customer name is undefined or null');

        return;
      }

      return individualCustomerName;
    }
  }
}

export const vendorOpportunityService = new VendorOpportunityService();
